// 로그 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역

// =================================================================================================
// 상수
// =================================================================================================
// 오류 로깅
const error = (...restParameters) => {
  console.error(restParameters);
};

// 정보 로깅
const info = (...restParameters) => {
  console.info(restParameters);
};

// 경고
const alert = (aObject) => {
  // window.alert(stringHelper.valueOfObject(aObject));
  window.alert(valueOfObject(aObject));
};

// object to string
const valueOfObject = (aObject) => {
  let s1;
  try {
    s1 = JSON.stringify(aObject); // string 화
  } catch (e) {
    error(e);
  }
  return s1;
};

// =================================================================================================
// 내보내기
// =================================================================================================
export default {
  alert,
  error,
  info,
};
